import { render, staticRenderFns } from "./ot-contract-details-form.vue?vue&type=template&id=4b3c2d57&scoped=true&"
import script from "./ot-contract-details-form.vue?vue&type=script&lang=ts&"
export * from "./ot-contract-details-form.vue?vue&type=script&lang=ts&"
import style0 from "./ot-contract-details-form.vue?vue&type=style&index=0&id=4b3c2d57&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b3c2d57",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VForm } from 'vuetify/lib/components/VForm';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VOverlay } from 'vuetify/lib/components/VOverlay';
installComponents(component, {VForm,VIcon,VOverlay})
